export default (function () {
    var loginResult = Promise.resolve();
    return {
        waitForLoginRequestComplete: loginResult
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-js/AuthenticationService-anonymous.js
// module id = 876
// module chunks = 0